"use strict";
document.querySelectorAll('.bundle-shop').forEach(function (elem) {
    var bundleCta = elem.querySelector('.bundle-shop__cta');
    if (!bundleCta) {
        console.error('bundleCta is not defined');
        return;
    }
    bundleCta.addEventListener('click', function () {
        var selectedProduct = elem.querySelector('.bundle-shop__input:checked');
        if (!selectedProduct) {
            console.error('selectedProduct is not defined');
            return;
        }
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: selectedProduct.getAttribute('data-variant-id'),
                quantity: 1,
                selling_plan: selectedProduct.getAttribute('data-selling-plan'),
            }),
        }).then(function () {
            document.dispatchEvent(new Event('fetchAndSlideCart'));
        });
    });
});
